import React from "react";

export const BlankFileIcon = () => {
  return (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.90039 4C3.90039 1.79086 5.69125 0 7.90039 0H23.4004L35.1004 12V36C35.1004 38.2091 33.3095 40 31.1004 40H7.90039C5.69125 40 3.90039 38.2091 3.90039 36V4Z"
        fill="url(#paint0_linear_2194_30969)"
      />
      <path
        d="M3.90039 4C3.90039 1.79086 5.69125 0 7.90039 0H23.4004L35.1004 12V36C35.1004 38.2091 33.3095 40 31.1004 40H7.90039C5.69125 40 3.90039 38.2091 3.90039 36V4Z"
        fill="#F5F5F7"
      />
      <path
        d="M23.4004 0L35.1004 12H27.4004C25.1912 12 23.4004 10.2091 23.4004 8V0Z"
        fill="#E5E5E5"
      />
      <defs>
        <linearGradient
          id="paint0_linear_2194_30969"
          x1="19.5004"
          y1="0"
          x2="19.5004"
          y2="40"
          gradientUnits="userSpaceOnUse">
          <stop stopOpacity="0.3" />
          <stop offset="1" stopOpacity="0.8" />
        </linearGradient>
      </defs>
    </svg>
  );
};
